var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompanyProjectsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE4BC",
    d: "M3.878 12.651L1 17.585V6a2 2 0 012-2h6.667l2.666 2.667H19a2 2 0 012 2v2H7.333a4.011 4.011 0 00-3.455 1.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M7.333 12H24a1 1 0 01.864 1.504l-3.02 5.173A2.662 2.662 0 0119.542 20H2.875a1 1 0 01-.864-1.504l3.019-5.173A2.665 2.665 0 017.333 12z"
  }))));
}

export default SvgCompanyProjectsActive;